import { Button, Divider, Input, Modal, Radio, Switch } from "antd";
import React from "react";
import FormNumber from "../../../components/common/FormNumber/FormNumber";

export default function ModalAdd({
  id,
  visible,
  handleSubmit,
  submitting,
  onClose,
  form,
  onChangeRadio,
  handleChangeNumber,
  handleChangeInput,
  onSubmit,
  errors,
}) {
  return (
    <Modal
      className="modal-add"
      centered
      title={id ? "Edit Outlet" : "Tambah Outlet"}
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      width={800}
      footer={[
        <Button
          onClick={onClose}
          style={{
            border: "0.75px solid #DCDCDC",
            borderRadius: 6,
            width: 120,
            height: 36,
            color: "#000",
            background: "#FFFFFF",
          }}
        >
          Kembali
        </Button>,
        <Button
          type="submit"
          disabled={submitting}
          onClick={onSubmit}
          style={{
            border: "0.75px solid #DCDCDC",
            borderRadius: 6,
            width: 120,
            height: 36,
            color: "#fff",
            background: "#2C465C",
          }}
        >
          Simpan
        </Button>,
      ]}
    >
      <div style={{ marginTop: 24 }}>
        <div className="d-flex w-100">
          <div style={{ flex: 1, marginRight: 5 }}>
            <div style={{ color: "#000" }}>Kode Outlet</div>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Kode outlet"
              value={form.outletCode}
              id={"outletCode"}
              onChange={handleChangeInput}
              error={errors.outletCode}
            />
            {errors.outletCode && (
              <p className="text-danger small">{errors.outletCode}</p>
            )}
          </div>
          <div style={{ flex: 1, marginLeft: 5 }}>
            <div style={{ color: "#000" }}>Nama Outlet</div>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Kode outlet"
              value={form.name}
              id={"name"}
              onChange={handleChangeInput}
              error={errors.name}
            />
            {errors.name && <p className="text-danger small">{errors.name}</p>}
          </div>
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <div>Alamat Outlet:</div>
        <Input.TextArea
          required
          rows="3"
          type="text"
          className="form-control border-DCDCDC text-input"
          placeholder="Alamat outlet"
          value={form.address}
          id={"address"}
          onChange={handleChangeInput}
          error={errors.address}
        />

        {errors.address && (
          <p className="text-danger small">{errors.address}</p>
        )}
      </div>

      {!id && (
        <div className="d-flex w-100 my-2">
          <div style={{ flex: 1, marginRight: 5 }}>
            <div style={{ color: "#000" }}>Modal Awal</div>
            <FormNumber
              style={styles.formNumber}
              suffix="Rupiah"
              value={form.initCapital}
              onValueChange={handleChangeNumber("initCapital")}
              error={errors.initCapital}
            />
          </div>
          <div style={{ flex: 1, marginRight: 5 }}>
            <div style={{ color: "#000" }}>Kas Awal</div>
            <FormNumber
              style={styles.formNumber}
              suffix="Rupiah"
              value={form.initPettyCash}
              onValueChange={handleChangeNumber("initPettyCash")}
              error={errors.initPettyCash}
            />
          </div>
        </div>
      )}
      <div className="d-flex w-100 mt-1">
        <div style={{ marginTop: 12, flex: 1, marginRight: 10 }}>
          <div>Jenis Outlet</div>
          <Radio.Group onChange={onChangeRadio("type")} value={form.type}>
            <Radio value={"internal"}>Internal</Radio>
            <Radio value={"external"}>Eksternal (Mitra)</Radio>
          </Radio.Group>
        </div>
        <div style={{ marginTop: 12, flex: 1, marginLeft: 10 }}>
          <div>Status</div>
          <Radio.Group onChange={onChangeRadio("status")} value={form.status}>
            <Radio value={"active"}>Aktif</Radio>
            <Radio value={"inactive"}>Non-Aktif</Radio>
          </Radio.Group>
        </div>
      </div>

      {form.type === "external" && (
        <div>
          <Divider dashed className="detail-divider" />
          <div style={{ fontWeight: "700" }} className="my-2">
            Komisi Pinjaman
          </div>
          <div className="d-flex w-100 mt-1">
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>Komisi Pinjaman (%)</div>
              <FormNumber
                style={styles.formNumber}
                suffix="%"
                value={form.loanCommission}
                onValueChange={handleChangeNumber("loanCommission")}
                error={errors.loanCommission}
              />
            </div>
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>Komisi Pinjaman Tanpa Bunga</div>
              <FormNumber
                style={styles.formNumber}
                suffix="%"
                value={form.loanCommissionNoCapital}
                onValueChange={handleChangeNumber("loanCommissionNoCapital")}
                error={errors.loanCommissionNoCapital}
              />
            </div>
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>Maksimal Komisi Pinjaman</div>
              <FormNumber
                style={styles.formNumber}
                suffix="Rupiah"
                value={form.maxLoanCommission}
                onValueChange={handleChangeNumber("maxLoanCommission")}
                error={errors.maxLoanCommission}
              />
            </div>
          </div>

          <Divider dashed className="detail-divider" />

          <div style={{ fontWeight: "700" }} className="my-2">
            Komisi Perpanjangan
          </div>
          <div className="d-flex w-100 mt-1">
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>Komisi Perpanjangan (%)</div>
              <FormNumber
                style={styles.formNumber}
                suffix="%"
                value={form.extensionCommission}
                onValueChange={handleChangeNumber("extensionCommission")}
                error={errors.extensionCommission}
              />
            </div>
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>
                Komisi Perpanjangan Tanpa Bunga
              </div>
              <FormNumber
                style={styles.formNumber}
                suffix="%"
                value={form.extensionCommissionNoCapital}
                onValueChange={handleChangeNumber(
                  "extensionCommissionNoCapital"
                )}
                error={errors.extensionCommissionNoCapital}
              />
            </div>
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>Maksimal Komisi Perpanjangan</div>
              <FormNumber
                style={styles.formNumber}
                suffix="Rupiah"
                value={form.maxExtensionCommission}
                onValueChange={handleChangeNumber("maxExtensionCommission")}
                error={errors.maxExtensionCommission}
              />
            </div>
          </div>

          <Divider dashed className="detail-divider" />

          <div style={{ fontWeight: "700" }} className="my-2">
            Potongan Komisi Untuk Agen
          </div>
          <div className="d-flex w-100 mt-1">
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>Potongan Komisi (%)</div>
              <FormNumber
                style={styles.formNumber}
                suffix="%"
                value={form.commissionCut}
                onValueChange={handleChangeNumber("commissionCut")}
                error={errors.commissionCut}
              />
            </div>
            <div style={{ flex: 1, marginRight: 5 }}>
              <div style={{ color: "#000" }}>
                Potongan Komisi Jika Tanpa Bunga (%)
              </div>
              <FormNumber
                style={styles.formNumber}
                suffix="%"
                value={form.commissionCutNoInterest}
                onValueChange={handleChangeNumber("commissionCutNoInterest")}
                error={errors.commissionCutNoInterest}
              />
            </div>
            {/* <div style={{ flex: 1, marginRight: 5 }} /> */}
          </div>

          {/* <div style={{ display: "flex", marginTop: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ color: "#A6A6A6" }}>Modal Awal :</div>
            </div>
            <div style={{ flex: 2, flexDirection: "row", display: "flex" }}>
              <NumberFormat
                // value={initCapital}
                isNumericString={true}
                // onValueChange={(e) => setInitCapital(e.floatValue)}
                thousandSeparator={"."}
                decimalSeparator={","}
                style={{
                  borderRadius: 6,
                  height: 36,
                  border: "0.75px solid #DCDCDC",
                  width: "100%",
                  paddingLeft: 6,
                }}
              />
              <p style={{ color: "#000", marginLeft: -50, marginTop: 6 }}>
                Rupiah
              </p>
            </div>
          </div>
          <div style={{ display: "flex", marginTop: 12 }}>
            <div style={{ flex: 1 }}>
              <div style={{ color: "#A6A6A6" }}>Kas Awal :</div>
            </div>
            <div style={{ flex: 2, flexDirection: "row", display: "flex" }}>
              <NumberFormat
                // value={initPettyCash}
                isNumericString={true}
                // onValueChange={(e) => setInitPettyCash(e.floatValue)}
                thousandSeparator={"."}
                decimalSeparator={","}
                style={{
                  borderRadius: 6,
                  height: 36,
                  border: "0.75px solid #DCDCDC",
                  width: "100%",
                  paddingLeft: 6,
                }}
              />
              <p style={{ color: "#000", marginLeft: -50, marginTop: 6 }}>
                Rupiah
              </p>
            </div>
          </div> */}
        </div>
      )}
    </Modal>
  );
}

const styles = {
  formNumber: {
    height: 36,
    border: "0.75px solid #DCDCDC",
    width: "100%",
    paddingLeft: 6,
    borderRadius: 6,
    borderColor: "#DCDCDC",
  },
};
